import { render, staticRenderFns } from "./RequestsTable.component.vue?vue&type=template&id=6044ed84"
import script from "./RequestsTable.component.vue?vue&type=script&lang=js"
export * from "./RequestsTable.component.vue?vue&type=script&lang=js"
import style0 from "./RequestsTable.component.vue?vue&type=style&index=0&id=6044ed84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports